import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'; 
import "./Navbar.scss";

const Navbar = () => {
  const [currentDateTime, setCurrentDateTime] = useState('');

  // Update date and time every minute
  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      const formattedDateTime = now.toLocaleString('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
      setCurrentDateTime(formattedDateTime);
    };

    updateDateTime(); // Set the initial time when the component mounts
    const intervalId = setInterval(updateDateTime, 60000); // Update every 60 seconds

    return () => clearInterval(intervalId); // Clear interval on component unmount
  }, []); // Empty dependency array to run effect only once on mount

  // Get user details from Redux store
  const userName = useSelector((state) => state.auth.user.userName); 
  const roleName = useSelector((state) => state.auth.user.roleName); 

  return (
    <div className='navbar-container'>
      <div className='navbar-head'>
        <h4>D R D A</h4>
        {/* <p>HOUSING THRUVALLUR</p> */}
      </div>

      <div className='navbar-details'>
        <div className='navbar-profile'> 
          <div className='profile-details'>
            <h5>{userName}</h5>
            {/* <p>{roleName}</p> */}
            <p>{currentDateTime}</p>
          </div>
          {/* <BsThreeDotsVertical /> */}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
